export default __webpack_public_path__ + "static/media/fgmw1.34ab3bc9.webp";